import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class MedTek21DataService
{

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getByAccession(accession) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/MedTek21/GetByAccession?accession=${accession}`;
      return this.httpClient.get(url);
   }

   public getRequisitionByAccession(accession) {
     let url: string = `${this.configService.getConfig().apiURL}v1/Internal/MedTek21/GetRequisitionByAccession?accession=${accession}`;

     return this.httpClient.get(url, { responseType: 'blob' as 'json'});
  }

  public createTestOrders() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/MedTek21/CreateTestOrders`;

    return this.httpClient.get(url);
  }
}
